import { Action, createReducer, on } from '@ngrx/store';
import { ClearData } from '@shared/models/prospect-data-models.interface';

import * as DocumentUploadActions from '../../actions/document-upload/document-upload.actions';

export interface IFileMetaData {
  fileName: string;
  objectURL: string;
}

export interface IDocumentUploadState {
  filesMetaData: IFileMetaData[];
  clearData: ClearData;
}

export const initialState: IDocumentUploadState = {
  filesMetaData: [],
  clearData: {
    clearOutcome: '',
    uploadedFilename: '',
  },
};

const documentUploadReducer = createReducer(
  initialState,
  on(DocumentUploadActions.updateFilesMetaData, (state, props) => {
    return {
      ...state,
      filesMetaData: props.payload,
    };
  }),
  on(DocumentUploadActions.updateProspectClearDocuments, (state, props) => ({
    ...state,
    clearData: props.payload,
  })),
);

export function reducer(state: IDocumentUploadState | undefined, action: Action) {
  return documentUploadReducer(state, action);
}

export const getHasClientUploadedFile = (state: IDocumentUploadState) =>
  state.filesMetaData.length > 0;
